import { useCallback } from 'react';
import { useStandort } from '../components/layouts/use-standort';
import { saveStandortStateValue, loadStandortStateValue, loadStandortState } from '../lib/standortState';

/**
 * Hook zum Speichern und Laden von Standort-spezifischen State-Werten
 * 
 * Beispiel:
 * ```tsx
 * const { saveState, loadState } = useStandortState();
 * 
 * // State speichern
 * saveState('selectedTeacher', '123');
 * 
 * // State laden
 * const teacher = loadState('selectedTeacher');
 * ```
 */
export function useStandortState() {
  const { selectedStandortId } = useStandort();

  /**
   * Speichert einen State-Wert für den aktuellen Standort
   */
  const saveState = useCallback((key: string, value: any) => {
    if (selectedStandortId === null) {
      console.warn('Kein Standort ausgewählt, State kann nicht gespeichert werden');
      return;
    }
    saveStandortStateValue(selectedStandortId, key, value);
  }, [selectedStandortId]);

  /**
   * Lädt einen State-Wert für den aktuellen Standort
   */
  const loadState = useCallback((key: string): any => {
    if (selectedStandortId === null) {
      return null;
    }
    return loadStandortStateValue(selectedStandortId, key);
  }, [selectedStandortId]);

  /**
   * Lädt den kompletten StandortState (inkl. Route)
   */
  const getFullState = useCallback(() => {
    if (selectedStandortId === null) {
      return null;
    }
    return loadStandortState(selectedStandortId);
  }, [selectedStandortId]);

  return {
    saveState,
    loadState,
    getFullState,
  };
}

